import { Button } from "primereact/button";
import { JVInput } from "../../../shared/JVInput";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { Fetch } from "../../../shared/Fetch";
import { useEffect, useState } from "react";
import { IMassMailWaitTimeSetting } from "./NextMassMailWaitTimeSettingTable";

interface IProps {
    reload: boolean,
    setReload: (reload: boolean) => void,
    toast: any,
}

const schema = yup.object({
    next_Mass_Mail_Wait_Time: yup.number().min(0).typeError("Minutes should be number").required("No of Minutes required"),
});

export const NextMassMailWaitTimeSettingForm = (props: IProps) => {
    const [loading, setLoading] = useState<boolean>(false);
    const { control, handleSubmit, formState: { errors }, reset, } = useForm<IMassMailWaitTimeSetting>({
        resolver: yupResolver(schema),
        defaultValues: {},
        shouldFocusError: false,
    });

    const saveToDB = async (body: IMassMailWaitTimeSetting) => {
        const method = "PUT";
        const message = "Updated Successfully";
        setLoading(true);
        delete body.updated_By;

        const resp = await Fetch("MassMail/UpdateNextMailsSendingMinutesSetting", method, body, null, null);
        if (resp) {
            props.toast.current.show({ severity: "success", detail: message, life: 3000, });
            props.setReload(!props.reload);
            setLoading(false);
        } else setLoading(false);
    };

    const onsubmit = (data: IMassMailWaitTimeSetting) => {
        saveToDB(data);
    };

    const loadTableData = async () => {
        const response = await Fetch("MassMail/getNextMailsSendingMinutesSetting", "GET", null, null, props.toast);
        if (response) {
            const data: Array<IMassMailWaitTimeSetting> = await response.json();
            reset(data[0]);
        }
    };

    useEffect(() => {
        loadTableData();
    }, []);

    return (
        <>
            <form onSubmit={handleSubmit(onsubmit)}>
                <div className="p-fluid formgrid grid">
                    <JVInput required column={4} label="Next Mass Mail Request Wait Time (in minutes)" control={control} name="next_Mass_Mail_Wait_Time" error={errors.next_Mass_Mail_Wait_Time?.message} />
                </div>
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button loading={loading} disabled={loading} style={{ width: "100px" }} label="SAVE" type="submit" ></Button>
                </div>
            </form>
        </>
    );
}